import React, {useEffect} from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import conversationStyles from 'src/App/Pages/Inbox/Conversation/styles.css'
import ConversationHeader from 'src/App/Pages/Inbox/Conversation/ConversationHeader'
import Button from 'orionsoft-parts/lib/components/Button'
import Loading from 'App/components/Loading'
import {useCreateConversation} from './hooks'
import styles from './styles.css'

export function Fallback() {
  return (
    <>
      <div className={styles.noMessages}>
        <Loading />
      </div>
      <div className={styles.information}></div>
    </>
  )
}

export default function Vehicle({match, history}) {
  const {vehicleId} = match.params

  const {vehicle} = useQuery({
    query: gql`
      query getVehicle($vehicleId: ID) {
        vehicle(vehicleId: $vehicleId) {
          _id
          code
          fullName
          completedOrdersCount
          categoryId
          phone
        }
      }
    `,
    variables: {vehicleId}
  })

  const {conversation} = useQuery({
    query: gql`
      query getLastConversation($vehicleId: ID) {
        conversation: getLastConversation(vehicleId: $vehicleId) {
          _id
        }
      }
    `,
    variables: {vehicleId}
  })

  useEffect(() => {
    if (conversation) {
      history.push(`/inbox/conversations/${conversation._id}`)
    }
  }, [conversation])

  const {createConversation} = useCreateConversation({vehicleId, history})

  return (
    <>
      <div className={conversationStyles.conversation}>
        <ConversationHeader vehicle={vehicle} />

        <div className={styles.noMessages}>
          <h3>
            No existen conversaciones pasadas con #{vehicle.code} {vehicle.fullName}
          </h3>
          <div>
            <Button primary onClick={createConversation}>
              Iniciar una conversación
            </Button>
          </div>
        </div>
      </div>
      <div className={conversationStyles.information}></div>
    </>
  )
}
